import React from 'react';
import "../css/input.css";
const Button = (props) => {
    return (
        <button type={"button"} onClick={props.onClick} className={`button ${props.className}`} style={props.style} disabled={props.disabled}>
            {props.children}
        </button>
    );
};

export default Button;